import axiosInstance from './axiosInstance';

/** Whether System Admin has Harvest Leads switched on for the caller's company. */
export const getLeadGenAccess = () => axiosInstance.get('/lead-gen/access');

export const getLeadProspects = (companyId, params = {}) =>
	axiosInstance.get('/lead-gen/prospects', {
		params: { companyId, ...params },
	});

export const getLeadProspectStats = (companyId, params = {}) =>
	axiosInstance.get('/lead-gen/prospects/stats', {
		params: { companyId, ...params },
	});

export const getLeadProspect = (id, companyId) =>
	axiosInstance.get(`/lead-gen/prospects/${id}`, { params: { companyId } });

export const pushLeadProspects = (payload, companyId) =>
	axiosInstance.post(
		'/lead-gen/prospects/push',
		{ ...payload, companyId },
		{ params: { companyId } },
	);

/** Convert harvested prospects into Outreach tracker leads. */
export const pushProspectsToOutreach = (payload, companyId) =>
	axiosInstance.post(
		'/lead-gen/prospects/to-outreach',
		{ ...payload, companyId },
		{ params: { companyId } },
	);
